import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./MartClientLogin.css";

const MartClientLogin = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/owner/client/login`, formData);
      if (res.data.success) {
        localStorage.setItem("marsUser", JSON.stringify(res.data.user));
        navigate("/mars-mart");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <div className="client-login-page">
      <div className="client-login-content">
        <button className="back-btn" onClick={() => navigate("/mars-mart/home")}>← Back</button>
        
        <div className="login-visual">
          <img src="https://cdn-icons-png.flaticon.com/512/3703/3703259.png" alt="Client" />
          <h1>Welcome Back</h1>
          <p>Login to order your favorites</p>
        </div>

        <form className="client-form" onSubmit={handleLogin}>
          {error && <p className="error-box">{error}</p>}
          <input 
            type="email" 
            placeholder="client@gmail.com" 
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            required 
          />
          <input 
            type="password" 
            placeholder="client123" 
            onChange={(e) => setFormData({...formData, password: e.target.value})}
            required 
          />
          <button type="submit" className="login-submit">LOGIN</button>
        </form>
        
        <p className="signup-text">New to MarsMart? <span>Create an account</span></p>
      </div>
    </div>
  );
};

export default MartClientLogin;